import React from 'react';

import { Alert, Checkbox, Form, Icon, Input, Row, Upload} from 'antd';
import { API_ENDPOINT } from '../../index';

import debounce from 'debounce';

const FormItem = Form.Item;

/**
 * Receives an enterprise and allows admins to edit it.
 * Calls this.props.onChange after 800 ms of calling FormItem.onChange
 */


class EnterpriseEditor extends React.Component{

	render(){

		const { enterprise } = this.props;
		const { getFieldDecorator } = this.props.form;
		const { image } = this.state;

		const formItemLayout = {
			labelCol: { span: 8 },
			wrapperCol: { span: 16 }
		}

		return (
			<div>
				<Form>
					
					<FormItem 
						{...formItemLayout}
						label="Company Name">
						
						{getFieldDecorator('companyName', {
							initialValue: enterprise.companyName,
							rules: [
								{ required: true },
								{ validator: this.validateCompanyName }
							],
						})(
							<Input 
								onChange={ this.handleChangeInput } 
								placeholder="Eezee Pte Ltd" />
						)}

					</FormItem>

					<FormItem {...formItemLayout} label="Credit Term Amount">
						{getFieldDecorator('creditTermAmount', {
							initialValue: enterprise.creditTermAmount,
							rules: [
								{ required: true },
								{ validator: this.validateCreditTermAmount }
							],
						})(
							<Input 
								addonBefore="$SGD" 
								onChange={ this.handleChangeInput } 
								placeholder="5000" />
						)}
					</FormItem>

					<FormItem {...formItemLayout} label="Credit Term Days">
						{getFieldDecorator('creditTermDays', {
							initialValue: enterprise.creditTermDays,
							rules: [
								{ required: true },
								{ validator: this.validateCreditTermsDays }
							],
						})(
							<Input 
								addonAfter="Days" 
								onChange={ this.handleChangeInput } 
								placeholder="45" />
						)}
					</FormItem>

					<FormItem {...formItemLayout} label="Mov Free Delivery">
						{getFieldDecorator('movFreeDelivery', {
							initialValue: enterprise.movFreeDelivery,
							rules: [
								{ required: true },
								{ validator: this.validateMovFreeDelivery }
							],
						})(
							<Input 
								addonBefore="$SGD" 
								onChange={ this.handleChangeInput } 
								placeholder="500" />
						)}
					</FormItem>

					{/* movFreeDelivery */}
					<FormItem
						help="All companies will be reviewed to govt for 3 quotes">
						{getFieldDecorator('government', {
							initialValue: enterprise.government,
						})(
							<Checkbox 
								onChange={ this.handleChangeInput }>
								Government Entity
							</Checkbox>
						)}
					</FormItem>

					<FormItem className="uploader-image-wrapper">
						<Alert 
							type="info" 
							message={
							<div>
								<Icon type="info-circle" style={{color: '#1890ff'}} /> Upload the company's logo if possible
							</div>
						}/>

						<Row 
							className="uploader-image-container " 
							type="flex" 
							justify="center"
							align="center"
							style={{
								backgroundColor: `${image? '#a0a0a0' : 'white'}`
								}}>

								{image?
									<img className="upload-image" src={image.url} alt='' />
									:
									null
								}
						</Row>

						 <Upload.Dragger 
						 	className="uploader-button"
							action={`${API_ENDPOINT}/api/upload/enterprise-image`}
							name='picture'
							accept="image/*"
							onChange={this.handleImageChange}
							withCredentials={true}
							beforeUpload={this.beforeUpload}
							showUploadList={false}
							>

						<Row>


							<p>
								<Icon type="inbox" />
							</p>
							<p>Company Logo</p>
							
						</Row>

							
						</Upload.Dragger>
					</FormItem>

				</Form>
				
			</div>
		)
	}

	constructor( props ){
		super(props);
		this.state = {
			image: false
		}

		this.asyncUpdateParentState = debounce(this.asyncUpdateParentState, 1500);
	}

	asyncUpdateParentState = () => {
		this.props.form.validateFields(
			(err, values) => {

				if(err){
					this.props.onError( err );
					return;
				}

				if(this.state.image) {
					values.image = this.state.image;
				}

				console.log("values = " , values)
				this.props.onChange( values );
			}
		);
	}

	handleChangeInput = () => {
		this.props.invalidateField({ loading: true });
		this.asyncUpdateParentState();
	}

	handleImageChange = (info) => {

        if (info.file.status === 'done') {
			let { image }= info.file.response;

			this.setState({
				image
			})
		}

		this.props.invalidateField({ loading: true });
		this.asyncUpdateParentState();
    } 

	validateCompanyName = (rule, value, cb) => {
		
		// const touched = this.props.form.isFieldTouched( rule.field );

		// if ( !touched ){
		// 	return cb();
		// }

		if( !value ){
			return cb("Company Name is required!");
		}
	
		cb();
	}


	validateCreditTermsDays = (rule, value, cb) => {
		
		// const touched = this.props.form.isFieldTouched( rule.field );

		// if ( !touched ){
		// 	return cb();
		// }

		if( isNaN(value) ){
			return cb("Please input numbers in (days)!");
		}

		if( value > 90 ){
			return cb("Max 90 days Credit Term");
		}

		if( value < 15 ){
			return cb("Min 15 days Credit Term");
		}
	
		cb();
	}

	validateCreditTermAmount = ( rule, value, cb ) => {

		// const touched = this.props.form.isFieldTouched( rule.field );

		// if ( !touched ){
		// 	return cb();
		// }

		if( isNaN(value) ){
			return cb("Please input numbers in ($SGD)!");
		}

		if( value > 300000 ){
			return cb("Max $300,000 Credit Amount");
		}

		if( value < 500 ){
			return cb("Min $500 Credit Amount");
		}

		cb();

	}

	validateMovFreeDelivery = ( rule, value, cb ) => {
		if( isNaN(value) ){
			return cb("Please input numbers in ($SGD)!");
		}

		if( value < 100 ){
			return cb("Min $100 Mov Free Delivery");
		}

		cb();
	}
}

export default Form.create({
	// mapPropsToFields( props ) {

	// 	const { enterprise = {} } = props;

  //   return {

	// 		government: Form.createFormField({
  //       value: enterprise.government,
	// 		}),

	// 		creditTermDays: Form.createFormField({
  //       value: enterprise.creditTermDays,
	// 		}),

	// 		creditTermAmount: Form.createFormField({
  //       value: enterprise.creditTermAmount,
	// 		}),

	// 		companyName: Form.createFormField({
  //       value: enterprise.companyName,
	// 		}),

	// 		movFreeDelivery: Form.createFormField({
  //       value: enterprise.movFreeDelivery,
	// 		})
			
  //   };
  // }
})(EnterpriseEditor);


// WEBPACK FOOTER //
// ./src/components/enterprise/editor.js